
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import NewNarrative from "./pages/NewNarrative";
import HowWeOperate from "./pages/HowWeOperate";
import RecommendedVersion from "./pages/RecommendedVersion";
import NewLanding from "./pages/NewLanding";
import New2Landing from "./pages/New2Landing";
import New3Landing from "./pages/New3Landing";
import New4Landing from "./pages/New4Landing";
import New4LandingEn from "./pages/New4LandingEn";
import { LanguageProvider, LanguageRouteSync } from "./contexts/LanguageContext";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <BrowserRouter>
        <LanguageProvider>
          <Toaster />
          <Sonner />
          <LanguageRouteSync />
          <Routes>
            <Route path="/" element={<New4Landing />} />
            <Route path="/en" element={<New4LandingEn />} />
            <Route path="/old" element={<Index />} />
            <Route path="/new" element={<NewLanding />} />
            <Route path="/new2" element={<New2Landing />} />
            <Route path="/new3" element={<New3Landing />} />
            <Route path="/new4" element={<New4Landing />} />
            <Route path="/new4-en" element={<New4LandingEn />} />
            <Route path="/new-narrative" element={<NewNarrative />} />
            <Route path="/how-we-operate" element={<HowWeOperate />} />
            <Route path="/recommended" element={<RecommendedVersion />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
